<template lang="pug">
  form.slice-newsletter-signup.call-to-action-row.bg-pink.text-18.md_text-20.xl_text-24.min-h-130.md_min-h-16vw.flex.items-center.justify-start.px-20.pb-15(@submit.prevent="subscribe", validate)
    //- wrapper
    .w-full.md_w-8x12.md_ml-3x12.flex.flex-wrap.md_items-end.md_px-20
      //- heading column
      .w-full.md_w-auto.mb-8.md_mb-0
        //- heading
        h6.whitespace-no-wrap Stay up to date
        //- privacy policy text (hangs on lnd)
        .relative
          .absolute.top-40.md_top-auto.md_pt-18.text-9.md_text-10 View our #[router-link.shadow-underline(to="/privacy-policy") privacy policy]

      //- input column
      .w-full.flex-1.md_w-auto.flex.items-end
        //- input row
        .flex-1.md_w-1x2.pr-20.md_px-40
          .relative
            //- (status)
            .absolute.overlay.cursor-pointer(v-show="status", @click="reset(false)") {{ status }}
            //- (input)
            div(:class="{'invisible': status}")
              label.sr-only Email
              input.w-full.pt-10ff.border-b.border-current.-mb-px(ref="input", v-model="email", type="email", name="email", required)

        //- sign up btn
        button.focus_bg-black-a10(type="submit")
          btn-boxed(size="smedium") Sign up
</template>

<script>
export default {
  name: 'SliceNewsletterSignUp',
  data () {
    return {
      email: '',
      status: null // 'Sending...'
    }
  },
  methods: {
    async subscribe (email) {
      this.status = 'Sending...'

      try {
        // submit...
        let resp = await fetch('/.netlify/functions/mailerlite-subscriber-add', {
          method: 'POST',
          body: JSON.stringify({ email: this.email })
        })
        resp = await resp.json()

        // ...API errors
        if (resp.error) {
          this.status = 'Error'
          return console.error(resp.error)
        }
        // ...success
        this.status = 'Thank you!'
        // reset
        setTimeout(() => this.reset(), 3000)
      } catch (e) {
        // connection error
        this.status = 'Error. Are you online?'
        console.error(e)
      }
    },

    reset (clear = true) {
      this.status = null
      if (clear) this.email = ''
      this.$nextTick(() => this.$refs.input.focus())
    }
  }
}
</script>

<style>
</style>
